export default __webpack_public_path__ + "static/media/icon-play-in-ext.6e54f0dc.svg";